import {
	NEW_CONTRACT_NAME_MIN_LENGTH,
	NEW_CONTRACT_TYPES,
} from "web_myplann/Goals/constants";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { trimmedNullable } from "web_myplann/Shared/Validation/trimmedNullable";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";
import { z } from "zod";

export const getNewContractFormSchema = (t: TranslateFunction) =>
	z.object({
		type: z.enum(NEW_CONTRACT_TYPES),
		name: z
			.string()
			.transform((value) => value.trim())
			.pipe(
				z
					.string()
					.min(
						NEW_CONTRACT_NAME_MIN_LENGTH,
						t(Resources.Goals.Detail.Solution.Pin.New.Missing.name),
					)
					.max(
						ValidationLimits.TextLength.LongName,
						t(Resources.Portfolio.AddShared.Validations.maxLength, {
							max: ValidationLimits.TextLength.LongName,
						}),
					),
			),
		value: z
			.number()
			.nullable()
			.pipe(
				z
					.number({
						invalid_type_error: t(
							Resources.Goals.Detail.Solution.Pin.New.Missing.value,
						),
					})
					.int(t(Resources.Portfolio.AddShared.Validations.positiveNumber))
					.min(1, t(Resources.Goals.Detail.Solution.Pin.New.Missing.value))
					.max(
						ValidationLimits.Amount.Max,
						t(Resources.Portfolio.AddShared.Validations.maxValue),
					),
			),
		contractNumber: trimmedNullable(
			z.string().max(
				ValidationLimits.TextLength.Name,
				t(Resources.Portfolio.AddShared.Validations.maxLength, {
					max: ValidationLimits.TextLength.Name,
				}),
			),
		),
		producer: trimmedNullable(
			z.string().max(
				ValidationLimits.TextLength.LongName,
				t(Resources.Portfolio.AddShared.Validations.maxLength, {
					max: ValidationLimits.TextLength.LongName,
				}),
			),
		),
		product: trimmedNullable(
			z.string().max(
				ValidationLimits.TextLength.LongName,
				t(Resources.Portfolio.AddShared.Validations.maxLength, {
					max: ValidationLimits.TextLength.LongName,
				}),
			),
		),
	});

export type NewContractFormInput = z.input<
	ReturnType<typeof getNewContractFormSchema>
>;
export type NewContractFormOutput = z.output<
	ReturnType<typeof getNewContractFormSchema>
>;
